module.exports = __webpack_public_path__ + "img/九州机构通客户操作手册7456.01ec7cf8.png";